<ng-container *ngIf="form != undefined">
    <div [formGroup]="form" class="general">
        <div class="feedback-area" #text_area>
            <div class="text-area">
                <textarea  name="value" formControlName="value" placeholder="Escreva aqui..."></textarea>
                <div class="feedback-area-buttons">
                    <button class="btn-primary"  [ngStyle]="objColor" (click)="finishQuestion()">{{ btnSubmit }}</button>
                    <button class="btn-default" (click)="closeForm(button_area, text_area)">X</button>
                </div>
            </div>
        </div>
        <div class="button-area" #button_area>
            <button class="btn-primary teste" [ngStyle]="objColor" (click)="openForm(button_area, text_area)">Responder</button>
        </div>
    </div>
</ng-container>